<script setup lang="ts">
import Sidebar from '@/parts/Sidenavbar.vue'
import Navbar from '@/parts/Navbar.vue'
import { useGlobalStore } from '@/stores/global';
import { context } from '@/services'

const globalStore = useGlobalStore()

</script>

<template>
    <!-- Sidebar component -->
    <div
      class="flex bg-background"
      :class="{
        'dark:bg-gray-900': context !== 'bayen_school',
        'dark:bg-[#1a0a11]': context === 'bayen_school'
      }"
    >

        <Sidebar />

        <main
        class="max-h-screen  overflow-y-auto flex-grow transition-all duration-300 ease-in-out"
        :class="{
            'w-0 ': globalStore.isToggled,
        }"
        >

            <Navbar />
            <div class="lg:p-6 md:p-4 p-3  transition-all duration-300 ease-in-out relative ">
                <slot />
            </div>

        </main>

    </div>
</template>

<style>
/* @import 'datatables.net-dt'; */
.datatable {
    margin: 15px;
}
</style>
